import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  hashedGiftCardToken: attr(String),
  giftCardToken: attr(String),
  panSuffix: attr(String)
});